'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.open = exports.OPEN = exports.confirmActiveThunk = exports.confirmActive = exports.confirmActivePayload = exports.endItem = exports.createListThunk = exports.createList = exports.CREATE_LIST = exports.createItemThunk = exports.createItem = exports.CREATE_ITEM = exports.confirmItem = exports.UPDATE_ITEM = exports.editListItem = exports.LISTITEM = exports.editCollection = exports.COLLECTION = exports.close = exports.CLOSE = undefined;

var _omitBy2 = require('lodash/fp/omitBy');

var _omitBy3 = _interopRequireDefault(_omitBy2);

var _now2 = require('lodash/now');

var _now3 = _interopRequireDefault(_now2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _constant2 = require('lodash/constant');

var _constant3 = _interopRequireDefault(_constant2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.payloadSelectorAction = payloadSelectorAction;
exports.thunkify = thunkify;
exports.confirmItemPayload = confirmItemPayload;
exports.endItemPayload = endItemPayload;
exports.toggleActionPrep = toggleActionPrep;
exports.toggleActionAnon = toggleActionAnon;
exports.addOrOpen = addOrOpen;
exports.toggle = toggle;

var _capeLodash = require('cape-lodash');

var _capeRedux = require('cape-redux');

var _capeSelect = require('cape-select');

var _capeReduxAuth = require('cape-redux-auth');

var _reduxGraph = require('redux-graph');

var _entity = require('./entity');

var _select = require('./select');

var _const = require('./const');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var meta = (0, _flow3.default)((0, _capeLodash.createObj)('action'), _constant3.default);
function payloadSelectorAction(type, payloadSelector) {
  return function () {
    return (0, _flow3.default)((0, _capeSelect.structuredSelector)({
      type: type,
      payload: payloadSelector.apply(undefined, arguments)
    }), (0, _omitBy3.default)(_isUndefined3.default));
  };
}
function thunkify(actionSelector) {
  return function (dispatch, getState) {
    return dispatch(actionSelector(getState()));
  };
}

// Close edit dialog.
var CLOSE = exports.CLOSE = 'collection/CLOSE';
var close = exports.close = (0, _capeRedux.createAction)(CLOSE, _noop3.default);
// Open edit list.
var COLLECTION = exports.COLLECTION = 'collection/COLLECTION';
var editCollection = exports.editCollection = (0, _capeRedux.createAction)(COLLECTION);
// Open edit list item.
var LISTITEM = exports.LISTITEM = 'collection/LISTITEM';
var editListItem = exports.editListItem = (0, _capeRedux.createAction)(LISTITEM);

var UPDATE_ITEM = exports.UPDATE_ITEM = 'collection/UPDATE_ITEM';

// Create an action that will update a ListItem as confirmed.
function confirmItemPayload(props) {
  return _extends({}, (0, _reduxGraph.requireIdType)(props, _const.LIST_ITEM), { actionStatus: _const.CONFIRMED, dateModified: (0, _now3.default)() });
}
var confirmItem = exports.confirmItem = (0, _capeRedux.createAction)(UPDATE_ITEM, confirmItemPayload, meta('CONFIRM_ITEM'));

var CREATE_ITEM = exports.CREATE_ITEM = 'collection/CREATE_ITEM';
// When user is adding to a specific collection. Create new ListItem entity.
var createItem = exports.createItem = payloadSelectorAction(CREATE_ITEM, _entity.listItemBuilder);
var createItemThunk = exports.createItemThunk = (0, _flow3.default)(createItem, thunkify);

// Calling with no args will create a Favs list. Returns thunk because we need a getState().
var CREATE_LIST = exports.CREATE_LIST = 'collection/CREATE_LIST';
var createList = exports.createList = payloadSelectorAction(CREATE_LIST, _entity.collectionListBuilder);
var createListThunk = exports.createListThunk = (0, _flow3.default)(createList, thunkify);

function endItemPayload(_ref) {
  var id = _ref.id;

  return { actionStatus: _const.ENDED, endTime: (0, _now3.default)(), id: id, type: _const.LIST_ITEM };
}
var endItem = exports.endItem = (0, _capeRedux.createAction)(UPDATE_ITEM, endItemPayload, meta('END_ITEM'));

// Find created/open item and close it via confirmFavorite action.
var confirmActivePayload = exports.confirmActivePayload = (0, _flow3.default)(_select.activeListItem, confirmItemPayload);
var confirmActive = exports.confirmActive = (0, _capeSelect.structuredSelector)({
  type: UPDATE_ITEM,
  payload: confirmActivePayload,
  meta: { action: 'CONFIRM_ACTIVE' }
});
var confirmActiveThunk = exports.confirmActiveThunk = (0, _constant3.default)(thunkify(confirmActive));

var OPEN = exports.OPEN = 'collection/OPEN';
// Open edit dialog. Send it an item object that has an id property.
var open = exports.open = (0, _capeRedux.createAction)(OPEN, _reduxGraph.requireIdType);

// TOGGLE
function toggleActionPrep(state) {
  // Make sure the user has a favs collection created. Returns created entity or undefined.
  if ((0, _select.userNeedsCollection)(state)) return createList()(state);
  if ((0, _select.activeListItem)(state)) return confirmActive(state);
  return null;
}
// If in favs remove it. Otherwise add it.
function toggleActionAnon(state, item) {
  // Is the item in the favs collection?\
  var list = (0, _select.findItemInFavs)(state, { item: item });
  if (list) return endItem(list);
  return createItem({ item: item, mainEntity: _select.favsListSelector })(state);
}
// Anon user. Create new collection & listItem.
// Need to decide if we add to favs or display option to create project.
function addOrOpen(state, item) {
  // We know user has a favs collection. Create new listItem or remove from favs collection.
  if ((0, _capeReduxAuth.isAnonymous)(state)) return toggleActionAnon(state, item);
  return open(item);
}

// Decides what to do when a user clicks the (+) favorite button on item that can be in list.
// toggle(listProps, item) - state is added as first arg by thunkAction()
function toggle(item) {
  return function (dispatch, getState) {
    var prepAction = toggleActionPrep(getState());
    if (prepAction) dispatch(prepAction);
    var addOpenItem = addOrOpen(getState(), item);
    return dispatch(addOpenItem);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-collection/lib/actions.js
// module id = 155
// module chunks = 0